export default "__VITE_ASSET__D2ihzi_V__"